export const countryList = {
  title: "Lista de países",
  line1:
    "Las fases generales del GDHM se enumeran a continuación para cada país participante. Las puntuaciones de los países sobre los indicadores determinan la fase general de la salud digital de un país.",
  line2:
    "Para un desglose más detallado de cada país, visite la página de cada país",
  exportButtonText: "EXPORTACIÓN DE DATOS PARA TODOS LOS PAÍSES",
};
